module.exports = __webpack_public_path__ + "img/eat_out_17.5c2db4ba.jpg";